import {Navigation, Swiper} from "swiper/dist/js/swiper.esm";

Swiper.use([Navigation]);
export function sliderMini(item) {
  return new Swiper(item.querySelector('.sliderMini__slider'), {
      speed: 500,
      slidesPerView: 3,
      slidesPerGroup: 3,
      spaceBetween: 10,
      watchOverflow: true,
      navigation: {
        nextEl: item.querySelector('.swiper-button-next'),
        prevEl: item.querySelector('.swiper-button-prev'),
      },
      breakpoints: {
        375: {
          slidesPerView: 2,
          slidesPerGroup: 2
        },
        768: {
          slidesPerView: 3,
          slidesPerGroup: 3
        },
        1200: {
          slidesPerView: 5,
          slidesPerGroup: 5
        },
      }
    }
  );
}
